export enum SubscriptionStatus {
  Future = 0,
  Active = 1,
  Frozen = 2,
  SuspendedDueToNonPayment = 3,
  Upgraded = 4,
  Transfered = 5,
  NotRenewing = 6,
  Cancelled = 7,
  CancelledDueToNonPayment = 8,
  PendingForMandatoryAction = 9,
  PendingForPaymentConfirmation = 10,
  Expired = 11,
  Void = 12
}

export enum ClientCheckedInEvents {
  Checked_in = 1,
  checked_out = -1,
}
export enum ClientCheckedInStatus {
  Accessed = 1,
  Denied = 0,
}



export enum PlanCategory {
  PayAsYouGo = 1,
  PaidInFull = 2,
  DropIn = 3,
  Contract = 4,
  ConvertToPayAsYouGo = 5
};

export enum PlanCategoryBehaviour {
  MemberShip = 1,
  AppointmentPackage = 2,
  ClassPackage = 3
}

export enum PlanType {
  PayAsYouGo = "Pay as you go",
  PaidInFull = "Paid in full",
  DropIn = "Drop-in",
  Contract = "Contract",
}




export enum PlanIntervalType {
  Day = 0,
  Week = 1,
  Month = 2
}


export enum ServiceCategoryBehaviour {
  MemberShip = 1,
  AppointmentPackage = 2,
  ClassPackage = 3
}

export enum PlanFreezeType {
  NoFreeze = -1,
  FreeFreeze = 1,
  PaidFreeze = 2
}

export enum SignUpStatus {
  Created = 1,
  Open = 2,
  WaiverDone = 3,
  MandatoryInformationDone = 4,
  AwaitingPayment = 5,
  SignUpSuccessfull = 6,
  SignUpFailed = 7,
  SignUpExpired = 8
}

export enum SignUpFinalStatus {
  Open = 0,
  Closed = 1
}

export enum BillingCycleWeek {
  "Sign-Up Date" = "0",
  "Sunday" = "-1",
  "Monday" = "-2",
  "Tuesday" = "-3",
  "Wednesday" = "-4",
  "Thursday" = "-5",
  "Friday" = "-6",
  "Saturday" = "-7",
}

export enum BillingCycleMonth {
  "Sign-Up Date" = "0",
  "1st of Every month" = "1",
  "2nd of Every month" = "2",
  "3rd of Every month" = "3",
  "4th of Every month" = "4",
  "5th of Every month" = "5",
  "6th of Every month" = "6",
  "7th of Every month" = "7",
  "8th of Every month" = "8",
  "9th of Every month" = "9",
  "10th of Every month" = "10",
  "11th of Every month" = "11",
  "12th of Every month" = "12",
  "13th of Every month" = "13",
  "14th of Every month" = "14",
  "15th of Every month" = "15",
  "16th of Every month" = "16",
  "17th of Every month" = "17",
  "18th of Every month" = "18",
  "19th of Every month" = "19",
  "20th of Every month" = "20",
  "21st of Every month" = "21",
  "22nd of Every month" = "22",
  "23rd of Every month" = "23",
  "24th of Every month" = "24",
  "25th of Every month" = "25",
  "26th of Every month" = "26",
  "27th of Every month" = "27",
  "28th of Every month" = "28",
  "29th of Every month" = "29",
  "30th of Every month" = "30",
  "31th of Every month" = "31",
}

export enum SignUpCharges {
  "KeyFobFees" = "KeyFob Fees",
  "SignUpFees" = "Sign-up Fees",
  "TransferFees" = "Transfer Fees",
  "FreezeFees" = "Freeze Fees"
}
export enum ContractExpiry {
  on_contract_expiry_contract_expires = "Contract Expires",
  on_contract_expiry_contract_auto_renew = "Auto renew",
  on_contract_expiry_convert_to_pay_as_you_go = "Convert to pay as you go"
}

export enum OnContractExpiry {
  ContractExpire = 1,
  ContractAutoRenew = 2,
  ContractConvertsToPayAsYouGo = 3,
}

export enum MembershipBehaviour {
  MemberShip = "Membership",
  AppointmentPackage = "Appointment Session",
  ClassPackage = "Class Session",
}

export enum ServiceBehaviour {
  Membership = 1,
  AppointmentPackage = 2,
  ClassPackage = 3
}

export enum PayModeLevel1 {
  Cash = 1,
  Card = 2,
  NetBanking = 3,
  UPI = 4,
  Wallet = 5,
  ACH = 6,
  Cheque = 7,
  Other = 8,
  Emandate = 9,
  Adjustment=10,
  PayTo = 11,
}

export enum PayModeLevel2 {
  Cash = 1,
  Debit = 2,
  Credit = 3,
  Emandate = 4,
  UPI = 5,
  Paytm = 6,
  AmazonPay = 7,
  Venmo = 8,
  ACH = 9,
  Cheque = 10,
  Sodexo = 11,
  NetBanking = 12,
  ApplePay = 13,
  CareemPay = 14,
  Knet = 15,
  OmanPay = 16,
  Fawry = 17,
  Benefit = 18,
  Mada = 19,
  Tabby = 20,
  Transfer = 21,
  PayTo = 22,
  Card = 23,
  GCash = 24,
  GooglePay = 25,
  Link = 26
}


export enum BalanceQuatationStatus {
  Created = 1,
  Open = 2,
  AwaitingPayment = 3,
  Successfull = 4,
  Failed = 5,
  Expired = 6
}


export enum ChargeQuatationStatus {
  Created = 1,
  Open = 2,
  AwaitingPayment = 3,
  Successfull = 4,
  Failed = 5,
  Expired = 6
}

export enum ChargeQuatationFinalStatus {
  Open = 0,
  Closed = 1
}

export enum BalanceQuatationFinalStatus {
  Open = 0,
  Closed = 1
}

export enum ContractCancel {
  None = 0,
  EndOfBillingPeriod = 1,
  EndOfContract = 2,
  ImmediateCancel = 3
}

export enum TransferType {
  LocationToLocation = 1,
  ClientToClient = 2

}


export enum TransferStatus {
  Initiated = 1,
  TransferFromApproved,
  TransferFromDeclined,
  Scheduled,
  Completed,
  Void,
  FailedOther,
  Expired,
  Decline,
}

// Temp created for transfer type subscriptions
export enum SubscriptionType {
  PaidInFull = 1,
  Recurring = 2
}

export enum OverLappingTypes
{
    NewSignup = 1,
    Freeze = 2,
    DateChange = 3,
    Transfer = 4,
}

export enum SignUpMode
{
    SignUp = 1,
    Transfer = 2,
    Upgrade = 3,
    MidCycleAddons=4,
    PaymentMethodUpdate=5
}

export enum ComplitionTargetDevice
{
  TabletApp = 1,
  Client = 2
}

export enum OccurenceType
{
    None = 0,
    AutoApplyOnOccurence = 1,
    AutoApplyBeforeCancellation = 2,
    ApplyManually = 3
}
